import { when } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { IntlProvider as IntlNextProvider } from 'react-intl-next';

import Store from '../store';
import UserStore from '../store/userStore';

import { DEFAULT_LOCALE, determineLocale, setUpForLocale } from './locales';

interface Props {
  children: React.ReactNode;
  userStore: UserStore;
}

interface State {
  locale?: string;
  messages: { [key: string]: string };
}

@observer
class UchiIntlProvider extends React.Component<Props, State> {
  state = {
    locale: undefined,
    messages: {},
  };

  componentDidMount(): void {
    when(
      () => this.props.userStore.isDone,
      () => {
        const locale = determineLocale(this.props.userStore.locale);
        setUpForLocale(locale).then(messages => {
          this.setState({
            locale,
            messages,
          });
        });
      },
    );
  }

  render() {
    const { locale, messages } = this.state;
    return (
      <IntlProvider locale={locale || DEFAULT_LOCALE} defaultLocale={DEFAULT_LOCALE} messages={messages}>
        <IntlNextProvider
          data-test-language={locale}
          locale={locale || DEFAULT_LOCALE}
          defaultLocale={DEFAULT_LOCALE}
          messages={messages}
        >
          <React.Fragment>{this.props.children}</React.Fragment>
        </IntlNextProvider>
      </IntlProvider>
    );
  }
}

export default inject(({ userStore }: Store) => ({ userStore }))(UchiIntlProvider);
